<script setup lang="ts">
// Reusable iOS-style status bar matching the real app screenshots (04:31 ☾)
defineProps<{ time?: string }>()
</script>

<template>
  <div class="app-statusbar">
    <span class="app-statusbar__left">
      {{ time ?? '04:31' }}<span class="app-statusbar__icon">☾</span>
    </span>
    <span class="app-statusbar__right">
      <span class="app-statusbar__icon">●●●</span>
      <span class="app-statusbar__icon">🛜</span>
      <span class="app-statusbar__icon">⚡</span>
    </span>
  </div>
</template>
